<template>
  <div class="wrap_two">
    <p class="type">
      <span class="title"> 2024 年 01 月税款计算</span>
      <total-tax-info
          v-if="Boolean(currentItem)"
          :current-ans="userAnswer"
      />
    </p>
    <div class="opt-btn">
      <el-space :size="14">
        <el-button type="primary" @click="">重新计算</el-button>
      </el-space>
      <el-space :size="14">

        <span style="font-size: 15px;">
           <el-icon color="#999999" style="margin-right: -1px;position: relative;top: 2px;"><WarningFilled/></el-icon>
          算税方式：<span style="color: #4285F4;font-size: 14px;">在线算税</span>
        </span>

        <el-button type="primary" plain>导出</el-button>
        <el-button type="primary" plain>展开查询条件</el-button>
      </el-space>
    </div>

    <div class="opera-bar">
      所得项目：
      <el-select
          size="small"
          v-model="currentItem"
          style="width: 180px"
          :clearable="false"
          popper-class="disable-option-dark-global"
          placeholder="请选择"
          @change="changeItem"
      >
        <el-option
            disabled
            label="正常工资薪金所得"
            value="正常工资薪金所得"/>
        <el-option disabled label="全年一次性奖金收入" value="全年一次性奖金收入"/>
        <el-option
            label="劳务报酬（一般、法律援助补贴、其他非连续劳务）"
            value="劳务报酬（一般、法律援助补贴、其他非连续劳务）"/>
      </el-select>

      <div class="grow"></div>

      <div class="item">申报总人数：{{ userAnswer.length }}人</div>
      <div class="item last">应补退税额：{{ footerData.length && footerData[0].Answer_TaxCreditPayable }}元</div>
    </div>

    <vxe-table
        border
        ref="tableRef"
        :show-footer="showFooter"
        :max-height="maxHeight"
        :data="tableData"
        :footer-data="footerData"
    >
      <vxe-column field="employeesNo" title="工号" width="150" align="center"/>
      <vxe-column field="name" title="姓名" width="150" align="center"/>
      <vxe-column field="certificateType" title="证照类型" width="150" align="center"/>
      <vxe-column field="idNumber" title="证照号码" width="150" align="center"/>

      <vxe-column field="belongPro" title="所得项目" width="150" align="center">
        <template #default>
          <span>一般劳务报酬所得</span>
        </template>
      </vxe-column>

      <vxe-column field="Answer_CurrentIncome" title="收入" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.Answer_CurrentIncome != null && row.Answer_CurrentIncome.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="Answer_Fee" title="费用" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.Answer_Fee != null && row.Answer_Fee.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="Answer_CurrentExemptIncome" title="免税收入" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.Answer_CurrentExemptIncome != null && row.Answer_CurrentExemptIncome.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="total_kc" title="扣除项目合计" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.total_kc != null && row.total_kc.toFixed(2) }}</span>
        </template>
      </vxe-column>

<!--      <vxe-column field="Answer_PreDeductibleContributions"
                  align="center"
                  title="累计准予扣除的捐赠额" width="150">
        <template #default="{row}">
          0.00
        </template>
      </vxe-column>-->

      <vxe-column field="CumulativeTaxableIncome"
                  align="center"
                  title="应纳税所得额" width="150">
        <template #default="{row}">
          <span>{{ row.CumulativeTaxableIncome != null && row.CumulativeTaxableIncome.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="TaxRate"
                  align="center"
                  title="税率/预扣率" width="150">
        <template #default="{row}">
          <span>{{ row.TaxRate }}%</span>
        </template>
      </vxe-column>

      <vxe-column field="CalculateDeductionsQuickly"
                  align="center"
                  title="速算扣除数" width="150">
        <template #default="{row}">
          <span>{{ row.CalculateDeductionsQuickly != null && row.CalculateDeductionsQuickly.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="CumulativeTaxPayable" title="应纳税额" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.CumulativeTaxPayable != null && row.CumulativeTaxPayable.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="TaxRelief" title="减免税额" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.TaxRelief != null && row.TaxRelief.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="Answer_ShouldTaxMount" title="应扣缴税额" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.Answer_ShouldTaxMount != null && row.Answer_ShouldTaxMount.toFixed(2) }}</span>
        </template>
      </vxe-column>

      <vxe-column field="Answer_TheAmountTaxWithheld" title="已缴税额" width="150" align="center">
        <template #default="{row}">
          0.00
        </template>
      </vxe-column>
      <vxe-column field="Answer_TaxCreditPayable" title="应补(退)税额" width="150" align="center">
        <template #default="{row}">
          <span>{{ row.Answer_TaxCreditPayable != null && row.Answer_TaxCreditPayable.toFixed(2) }}</span>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script setup>
import Big from 'big.js';
import {useTaxStore} from '@/store/modules/tax.js'
import {onBeforeUnmount, onMounted, onUnmounted} from 'vue';
import TotalTaxInfo from "./totalTaxInfo.vue";

const taxStore = useTaxStore()
const {userAnswer} = storeToRefs(taxStore);
const tableData = ref([])
const tableRef = ref(null)
const maxHeight = ref('300px')


onMounted(() => {
  maxHeight.value = ((window.innerHeight | document.documentElement.clientHeight | document.documentElement.clientHeight) - 290) + 'px'
})

const currentItem = ref('')

function changeItem() {
  if (currentItem.value == '劳务报酬（一般、法律援助补贴、其他非连续劳务）') {
    tableData.value = userAnswer.value.map(m => {

      let CumulativeTaxableIncome // 应纳税所得额
      if (m.Answer_CurrentIncome <= 4000) {
        CumulativeTaxableIncome = parseFloat(new Big(m.Answer_CurrentIncome).minus(800).toString())
      } else {
        CumulativeTaxableIncome = parseFloat(new Big(m.Answer_CurrentIncome).times(0.8).toString())
      }

      let TaxRate = 0, CalculateDeductionsQuickly = 0
      if (CumulativeTaxableIncome <= 20000) {
        TaxRate = 20
        CalculateDeductionsQuickly = 0
      } else if (CumulativeTaxableIncome <= 50000) {
        TaxRate = 30
        CalculateDeductionsQuickly = 2000
      } else {
        TaxRate = 40
        CalculateDeductionsQuickly = 7000
      }

      const taxAmount = parseFloat(new Big(CumulativeTaxableIncome)
          .times(new Big(TaxRate / 100))
          .minus(new Big(CalculateDeductionsQuickly)).toString())
      return {
        ...m,
        Answer_CurrentExemptIncome: m.Answer_CurrentExemptIncome,
        CumulativeTaxableIncome,
        TaxRate,
        CalculateDeductionsQuickly: CalculateDeductionsQuickly,
        CumulativeTaxPayable: taxAmount,
        Answer_ShouldTaxMount: taxAmount,
        Answer_TaxCreditPayable: taxAmount,
      }
    })

    let Answer_CurrentIncome = new Big(0), Answer_CurrentExemptIncome = new Big(0),
        CumulativeTaxableIncome = new Big(0), CumulativeTaxPayable = new Big(0),
        TaxRelief = new Big(0), Answer_ShouldTaxMount = new Big(0),
        Answer_TaxCreditPayable = new Big(0), Answer_Fee = new Big(0), total_kc = new Big(0),
        CalculateDeductionsQuickly = new Big(0)
    tableData.value.forEach(row => {
      Answer_CurrentIncome = Answer_CurrentIncome.plus(row.Answer_CurrentIncome)
      Answer_CurrentExemptIncome = Answer_CurrentExemptIncome.plus(row.Answer_CurrentExemptIncome)
      CumulativeTaxableIncome = CumulativeTaxableIncome.plus(row.CumulativeTaxableIncome)
      CumulativeTaxPayable = CumulativeTaxPayable.plus(row.CumulativeTaxPayable)
      TaxRelief = TaxRelief.plus(row.TaxRelief)
      Answer_ShouldTaxMount = Answer_ShouldTaxMount.plus(row.Answer_ShouldTaxMount)
      Answer_TaxCreditPayable = Answer_TaxCreditPayable.plus(row.Answer_TaxCreditPayable)
      Answer_Fee = Answer_Fee.plus(row.Answer_Fee)
      CalculateDeductionsQuickly = CalculateDeductionsQuickly.plus(row.CalculateDeductionsQuickly)
      total_kc = total_kc.plus(row.total_kc)
    })
    footerData.value = [
      {
        employeesNo: '合计',
        name: `记录数：${userAnswer.value.length}`,
        certificateType: '-',
        idNumber: '-',
        belongPro: '-',
        total_kc: total_kc.toFixed(2),
        Answer_PreDeductibleContributions: '0.00',
        TaxRate: '--',
        CalculateDeductionsQuickly: CalculateDeductionsQuickly.toFixed(2),
        Answer_TheAmountTaxWithheld: '0.00',
        Answer_CurrentIncome: Answer_CurrentIncome.toFixed(2),
        Answer_CurrentExemptIncome: Answer_CurrentExemptIncome.toFixed(2),
        CumulativeTaxableIncome: CumulativeTaxableIncome.toFixed(2),
        CumulativeTaxPayable: CumulativeTaxPayable.toFixed(2),
        TaxRelief: TaxRelief.toFixed(2),
        Answer_ShouldTaxMount: Answer_ShouldTaxMount.toFixed(2),
        Answer_TaxCreditPayable: Answer_TaxCreditPayable.toFixed(2),
        Answer_Fee: Answer_Fee.toFixed(2),
      }
    ]
    userAnswer.value = tableData.value
    showFooter.value = true
  }
}

const showFooter = ref(false)
const footerData = ref([])

onBeforeUnmount(() => {
  if (tableData.value.length) {// 有数据，说明已经计算过了，离开时保存数据
    userAnswer.value = tableData.value
  }
})

</script>

<style lang="scss" scoped>
.wrap_two {
  width: 100%;

  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
    }
  }

  .opera-bar {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    .grow {
      flex-grow: 1;
    }

    .item {
      margin-right: 30px;

      &.last {
        margin-right: 0;
      }
    }
  }

  .opt-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
}
</style>
